import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Shield, Gauge } from 'lucide-react';
import { Button } from '../components/Button';

export function IPTransitPage() {
  const { t } = useTranslation();

  const handleQuoteRequest = () => {
    window.location.href = 'mailto:info@synthohosting.net?subject=IP Transit Quote Request';
  };

  return (
    <div className="pt-16">
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">{t('ipTransit.title')}</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('ipTransit.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Globe className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('ipTransit.features.network.title')}</h3>
            <p className="text-gray-600">{t('ipTransit.features.network.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('ipTransit.features.protection.title')}</h3>
            <p className="text-gray-600">{t('ipTransit.features.protection.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Gauge className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('ipTransit.features.capacity.title')}</h3>
            <p className="text-gray-600">{t('ipTransit.features.capacity.description')}</p>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg mb-16">
          <h2 className="text-2xl font-bold mb-4">{t('ipTransit.specs.title')}</h2>
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">{t('ipTransit.specs.title')}</h3>
              <ul className="space-y-3">
                {t('ipTransit.specs.items', { returnObjects: true }).map((item: string, index: number) => (
                  <li key={index} className="flex items-center">
                    <svg className="w-5 h-5 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">{t('ipTransit.specs.title')}</h3>
              <ul className="space-y-3">
                {t('ipTransit.specs.benefitsList', { returnObjects: true }).map((item: string, index: number) => (
                  <li key={index} className="flex items-center">
                    <svg className="w-5 h-5 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <Button variant="primary" onClick={handleQuoteRequest}>{t('common.getQuote')}</Button>
        </div>
      </div>
    </div>
  );
}